'use strict';



const $ = require('jquery');
const accounting = require('accounting');
const confirmFormSubmit = require('./confirm-form-submit');
const calculateReturn = require('./calculate-return');
const errorClassName = 'c-input-container--error';



module.exports = class InvestmentForm {



	constructor($container) {

		if($container.length < 1) {
			return;
		}

		this.elements = {
			$inputContainer: $container.find('.js-investment-form-input-container'),
			$input: $container.find('.js-investment-form-input'),
			$output: $container.find('.js-investment-form-output'),
			$warning: $container.find('.js-investment-form-warning'),
			$container
		};

		this.state = {
			rate: $container.data('rate'),
			submitting: false
		};

		this.init();

	}



	init() {

		const {
			$inputContainer,
			$input,
			$output,
			$container
		} = this.elements;

		$container.on('submit', e => {
			if(this.state.submitting && !e.notDuplicate) {
				e.preventDefault();
				return;
			}
		});

		confirmFormSubmit(
			$container,
			$form => {

				if(this.investmentLimitExceeded()) {
					this.removeError();
					$input
						.val(this.getInvestmentLimit())
						.trigger('change');
				}

				const investment = accounting.formatNumber(this.getInvestment(), 2);
				const returnAmount = accounting.formatNumber(this.getReturn(), 2);
				const remainingTermDays = $container.data('remaining-term-days');

				const overdueUnit = remainingTermDays === -1
					? 'day'
					: 'days';

				let appendMessage = ''

				if(remainingTermDays < 0) {
					appendMessage = `
						<p>Please be aware this loan is ${remainingTermDays * -1} ${overdueUnit} overdue so may be considered a higher risk investment. Please ensure you have read the 'Recent Updates' information for this loan.</p>
						<p><sup>†</sup> For more information please see <a href='https://support.lendy.co.uk/hc/en-us/articles/115004162069-Can-you-tell-me-more-about-the-bonus-accrual-scheme-' target='_blank' rel='noopener'>"Can you tell me more about the bonus accrual scheme"</a>.</p>
						<p>This loan is currently in arrears (the borrower is not making their contracted payments or the loan has expired). The debt is being pursued, but we cannot guarantee repayment of the loan in full. A default fee is charged to borrowers in arrears, and you will be entitled to a portion of this fee (enhanced monthly interest rate of 50% of the existing monthly interest rate). You will receive this fee<sup>†</sup> (and the contracted loan repayments), when the borrower repays their arrears, or the property is repossessed (and sufficient equity is available after the subsequent sale). The secondary market has higher potential risks, for lenders. You should ensure you fully understand the risks, and take professional advice, if you feel it is necessary.</p>
					`;
				} else {
					appendMessage = `<p>Please ensure you have read the 'Recent Updates' information for this loan.</p>`;
				}

				return `
          <div class='s-text'
            <p>Are you sure you wish to fund this loan with £${investment} for a return of £${returnAmount} per month?</p>
            ${appendMessage}
          </div>
        `;

			},
			$form => this.state.submitting = true
		);

		$input.on('keyup change', () => {
			const returnVal = this.getReturn();
			$output.text(accounting.formatNumber(returnVal, 2));
		});

		$input.on('keyup change', () => {
			if(this.investmentLimitExceeded()) {
				this.addError();
				return
			}
			this.removeError();
		});

	}



	addError() {
		const { $inputContainer, $warning } = this.elements;
		$inputContainer.addClass(errorClassName);
		$warning
			.html(`<p class='u-milli  u-centre-text  u-text-error'>Investment exceeds your available funds. Press "Invest" to continue with your available balance of <strong>£${accounting.formatNumber(this.getInvestmentLimit(), 2)}</strong>.</p>`)
			.show();
	}



	removeError() {
		const { $inputContainer, $warning } = this.elements;
		this.elements.$inputContainer.removeClass(errorClassName);
		$warning
			.empty()
			.show();
	}



	getInvestment() {
		return this.elements.$input.val().replace(/[^0-9\.]+/g, '') || 0;
	}



	getInvestmentLimit() {
		return window.investmentLimit || 0;
	}



	investmentLimitExceeded() {
		return this.getInvestment() > this.getInvestmentLimit();
	}



	getReturn() {
		return calculateReturn(this.getInvestment(), this.state.rate);
	}



};
